(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["complementary-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('grande-addons')) {
  customElements.define('grande-addons', class extends HTMLElement {
    connectedCallback() {
      if (this.setup) return;
      this.setup = true;
      this.cartVariants = new Set();
      this.cartRevision = 0;
      this.pendingForms = new Set();
      this.dialog = this.querySelector('dialog');
      this.cards = this.querySelector('[data-go-cards]');
      this.mainForm = document.getElementById(this.dataset.mainForm);
      if (!this.dialog || !this.mainForm) return;
      const buyBlock = this.mainForm.closest('.product-info__block-item');
      if (buyBlock) buyBlock.insertAdjacentElement('afterend', this);
      this.controller = new AbortController();
      const signal = this.controller.signal;
      document.addEventListener('submit', event => {
        const isMain = event.target === this.mainForm;
        const isExtra = this.contains(event.target) && event.target.matches('form');
        if (!isMain && !isExtra) return;
        if (this.pendingForms.has(event.target) || (isExtra && this.cartVariants.has(event.target.elements.id.value))) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        if (event.target.checkValidity()) {
          this.pendingForms.add(event.target);
          this.querySelector('[data-go-recovery]').hidden = true;
          setTimeout(() => {
            if (this.isConnected && this.pendingForms.has(event.target)) {
              this.querySelector('[data-go-recovery]').hidden = false;
              this.refreshCart();
            }
          }, 15000);
        }
      }, {capture:true, signal});
      document.addEventListener('cart:error', event => this.pendingForms.delete(event.target), {signal});
      this.addEventListener('click', event => {
        if (event.target.closest('[data-go-review]')) this.open(false, event.target);
        if (event.target.closest('[data-go-close]')) this.dialog.close();
      }, {signal});
      this.dialog.addEventListener('close', () => {
        this.querySelector('[data-go-inline]').append(this.cards);
        this.returnFocus?.focus();
      }, {signal});
      this.addEventListener('change', event => {
        if (event.target.matches('select[name="id"]')) {
          event.target.closest('[data-go-card]').querySelector('[data-go-price]').textContent = event.target.selectedOptions[0].dataset.price;
          this.updateCards();
        }
      }, {signal});
      document.addEventListener('variant:add', event => {
        const isMain = event.target === this.mainForm;
        const isExtra = this.contains(event.target);
        if (!isMain && !isExtra) return;
        this.pendingForms.delete(event.target);
        this.updateCart(event.detail.cart);
        if (isMain) {
          this.suppressDrawer = true;
          this.querySelector('[data-go-status]').textContent = '';
          this.open(true, document.activeElement);
        } else {
          this.suppressDrawer = true;
          this.querySelector('[data-go-status]').textContent = event.detail.items.map(item => item.product_title || item.title).join(', ') + ': ' + this.dataset.addedLabel;
          this.querySelector('[data-go-continue]').textContent = this.dataset.continueLabel;
        }
      }, {signal});
      document.addEventListener('cart:change', event => {
        if (this.suppressDrawer && event.detail.baseEvent === 'variant:add') {
          event.detail.baseEvent = 'accessories:review';
          this.suppressDrawer = false;
        }
        this.updateCart(event.detail.cart);
      }, {capture:true, signal});
      window.addEventListener('pageshow', event => {
        if (event.persisted && this.dialog.open) this.dialog.close();
        this.refreshCart();
      }, {signal});
      this.refreshCart();
    }
    disconnectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected) {
          this.controller?.abort();
          if (this.dialog?.open) this.dialog.close();
          this.setup = false;
        }
      });
    }
    async refreshCart() {
      const revision = this.cartRevision;
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js');
        if (response.ok) {
          const cart = await response.json();
          if (revision === this.cartRevision) this.updateCart(cart);
        }
      } catch (_) {}
    }
    updateCart(cart) {
      if (!cart?.items) return;
      this.cartRevision++;
      this.cartVariants = new Set(cart.items.map(item => String(item.variant_id)));
      this.updateCards();
    }
    updateCards() {
      this.querySelectorAll('[data-go-card]').forEach(card => {
        const input = card.querySelector('[name="id"]');
        const button = card.querySelector('[data-go-add]');
        const inCart = this.cartVariants.has(input.value);
        button.dataset.addAriaLabel ||= button.getAttribute('aria-label');
        button.setAttribute('aria-label', inCart ? card.querySelector('.go-addons__name').textContent + ': ' + this.dataset.addedLabel : button.dataset.addAriaLabel);
        button.disabled = inCart;
        button.textContent = inCart ? this.dataset.addedLabel : this.dataset.addLabel;
      });
    }
    open(added, trigger) {
      if (this.dialog.open) return;
      this.returnFocus = trigger;
      this.querySelectorAll('[data-go-main-added]').forEach(element => element.hidden = !added);
      this.querySelector('[data-go-dialog-cards]').append(this.cards);
      this.dialog.showModal();
      this.dialog.querySelector('h2').focus();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
